// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// https://www.honeybadger.io/blog/angular-rails-5/
// import "core-js/stable";
// import "regenerator-runtime/runtime";

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Hotwire: Stimulus
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Hotwire: Turbo (Disabled by default for safe migration)
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"

// Rails UJS initialization
Rails.start()
//Turbolinks.start()
ActiveStorage.start()

// Stimulus initialization
const application = Application.start()
const context = require.context("../controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

// Debug info in development
if (process.env.RAILS_ENV === 'development') {
  application.debug = false  // Disabled debug logs
  window.Stimulus = application
}

// Turbo: disabled by default for gradual migration
// Enable this when you are ready to use Turbo
if (typeof Turbo !== 'undefined') {
  Turbo.session.drive = false
  // Exported for use elsewhere
  window.Turbo = Turbo
}

import * as Routes from 'routes';
window.Routes = Routes;

window.__ssbenv = process.env.RAILS_ENV;
